import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { useMemo } from 'react'
import { metodoPrograma } from '../../../components/api'
import { telefoneMask } from '../../../utils/masks'

const EdicaoFornecedor = ({ dados, voltar }) => {
  const retornaFornecedor = useMemo(
    () => ({
      idFornecedor: dados?.[0] || undefined,
      dsNome: dados?.[1] || '',
      dtInclusao: dados?.[2] || undefined,
      dtExclusao: dados?.[3] || undefined,
      dsTelefone: dados?.[4] || '',
      dsEmail: dados?.[5] || '',
    }),
    [dados],
  )

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <Formik
      enableReinitialize
      initialValues={retornaFornecedor}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsNome"
                label="Nome"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsTelefone"
                label="Telefone"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                InputProps={telefoneMask}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsEmail"
                label="E-mail"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default EdicaoFornecedor
